var _rect, _path, _g, _path2, _path3, _circle, _circle2, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 225,
    viewBox: "0 0 221 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 114.469,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_1485_30998)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 83.7737C105.039 82.2704 110.247 82.2332 115.14 83.6667L201.676 109.016C207.399 110.692 207.437 118.786 201.729 120.516L115.378 146.683C110.337 148.211 104.95 148.171 99.9323 146.569L18.214 120.489C12.618 118.703 12.6564 110.771 18.2695 109.04L100.166 83.7737Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1485_30998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146 115.032C146 116.015 129.044 115.032 117.694 115.032C106.344 115.032 89 114.234 89 113.25C89 112.266 98.201 111.469 109.551 111.469C120.901 111.469 146 114.048 146 115.032Z",
    fill: "#7294FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7681 108.64L92.7838 114.274L142 21.9688L128.452 17.0423C126.53 16.3435 124.441 16.2506 122.464 16.7762L82.9579 27.2832C80.3295 27.9822 78.5 30.3618 78.5 33.0816L78.5 103.298C78.5 105.551 79.7622 107.614 81.7681 108.64Z",
    fill: "url(#paint1_linear_1485_30998)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.457 38.656C90.457 35.9016 92.3324 33.501 95.0049 32.8344L139.133 21.8276C142.919 20.8832 146.585 23.7471 146.585 27.6492L146.585 96.0243C146.585 98.6646 144.859 100.995 142.333 101.764L98.2053 115.205C94.3504 116.38 90.457 113.495 90.457 109.466L90.457 38.656Z",
    fill: "#4671F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 60.4681,
    r: 20,
    fill: "url(#paint2_linear_1485_30998)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 60.4681,
    r: 4,
    fill: "#4671F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82.3385C98 79.925 99.2209 77.6753 101.244 76.36L113.204 68.5865C114.791 67.555 116.79 69.1003 116.191 70.8958L111.589 84.7005C110.64 87.5481 107.975 89.4689 104.974 89.4689C101.122 89.4689 98 86.3467 98 82.4952L98 82.3385Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1485_30998",
    x: 75,
    y: 97.4689,
    width: 85,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1485_30998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1485_30998",
    x1: 206,
    y1: 169.469,
    x2: 14,
    y2: 169.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1485_30998",
    x1: 117,
    y1: 2.46875,
    x2: 70.0001,
    y2: 61.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1485_30998",
    x1: 81.5001,
    y1: 94.4688,
    x2: 138,
    y2: 49.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.ded5f0a7756fea11dfefa00493447a30.svg";
export { ForwardRef as ReactComponent };